<template>
  <Dialog v-model="showDialog">
    <ul class="activity-list-wrapper">
      <li class="activity-item" :style="{ borderColor: cardDescColor }" v-for="(item, index) in activityList" :key="`city_${index}`" @click="handleChoose(item)">
        {{ item.activityName }}
      </li>
    </ul>
  </Dialog>
</template>

<script>
import Dialog from "../Dialog"
import { mapGetters } from "vuex"

export default {
  name: "uiChooseCityDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    activityList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    handleChoose(activityItem) {
      this.$emit("choose", activityItem)
      window.location.href = activityItem.url
    }
  },
  components: {
    Dialog
  },
  computed: {
    ...mapGetters({
      fontColor: "activityInfo/fontColor"
    }),
    cardDescColor() {
      function hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
        return result
          ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            }
          : {}
      }
      const { r, g, b } = hexToRgb(this.fontColor)
      return `rgba(${r}, ${g}, ${b}, 0.5)`
    },
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-list-wrapper {
  margin-top: 80px;
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 592px;
  min-height: 400px;
  overflow: auto;
  width: 750px;
  .activity-item {
    width: 400px;
    height: 56px;
    line-height: 56px;
    border-width: 1px;
    border-style: solid;
    border-radius: 50px;
    font-size: 18px;
    padding: 0 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 20px;
    flex: none;
    text-align: center;
    &:active {
      opacity: 0.7;
    }
  }
}
</style>
